var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M13.0979 1.8541C13.6966 0.0114784 16.3034 0.0114794 16.9021 1.8541L19.0413 8.43769C19.309 9.26174 20.0769 9.81966 20.9434 9.81966H27.8658C29.8032 9.81966 30.6088 12.2989 29.0413 13.4377L23.441 17.5066C22.74 18.0159 22.4467 18.9186 22.7145 19.7426L24.8536 26.3262C25.4523 28.1689 23.3433 29.7011 21.7759 28.5623L16.1756 24.4934C15.4746 23.9841 14.5254 23.9841 13.8244 24.4934L8.22409 28.5623C6.65666 29.7011 4.5477 28.1689 5.14641 26.3262L7.28555 19.7426C7.5533 18.9186 7.25998 18.0159 6.559 17.5066L0.958665 13.4377C-0.608762 12.2989 0.19679 9.81966 2.13424 9.81966H9.05664C9.92309 9.81966 10.691 9.26174 10.9587 8.43769L13.0979 1.8541Z",
    fill: "#F5B700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.80805eddd60af97c0183934f1f147568.svg";
export { ForwardRef as ReactComponent };